module.exports = __webpack_public_path__ + "img/zhut2.6c807d9f.jpg";